import { AlertCircle } from "lucide-react";

/**
 * Renders an error from the assistant turn as a normal-style message
 * with a subtle leading icon, so it reads like a regular reply rather
 * than a coloured error block. The icon is the only visible cue that
 * this turn failed.
 */
export const ErrorMessage = ({
  message = "An unexpected error occurred. Please try again.",
}: {
  message?: string;
  timestamp?: string;
  onRetry?: () => void;
}) => {
  return (
    <div className="flex items-start gap-2 min-w-0 max-w-full w-full">
      <AlertCircle
        aria-label="Error"
        className="size-4 text-muted-foreground shrink-0 mt-1"
      />
      <div className="text-sm leading-relaxed text-foreground break-words wrap-anywhere min-w-0">
        {message}
      </div>
    </div>
  );
};
